import { styled } from "styled-components";

export const CategoryWrapper = styled.div`
  display: flex;
  max-width: 500px;
  max-height: 500px;
  gap: 12px;
`;
